export const LS_LOCALE = "app.locale";
export const LS_ACCESS_TOKEN = "app.access_token";
export const LS_REFRESH_TOKEN = "app.refresh_token";
export const LS_DEVICE_ID = "app.device_id";
export const LS_LAST_SUPPORT_TIME = "app.support_last_time"

export const MODE_CREATE = "create";
export const MODE_EDIT = "edit";

export const TRANSACTION_ACTION_SET_CATEGORY = 1;
export const TRANSACTION_ACTION_DELETE = 2;
export const TRANSACTION_ACTION_SET_TRANSFER = 3;
export const TRANSACTION_ACTION_ADD_TAG = 4;
export const TRANSACTION_ACTION_REMOVE_TAG = 5;
export const TRANSACTION_ACTION_BOOK_NOW = 6;

export const TRANSACTION_TYPE_DEFAULT = 1;
export const TRANSACTION_TYPE_TRANSFER = 2;

export const PORTFOLIO_TRANSACTION_TYPE_BUY = 1;
export const PORTFOLIO_TRANSACTION_TYPE_SELL = 2;
export const PORTFOLIO_TRANSACTION_TYPE_SPLIT = 3;

export const AMOUNT_REGEX = /^(\d+[.,]?\d?\d?\d?)?$/;
export const NEGATIVE_AMOUNT_REGEX = /^-?(\d+[.,]?\d?\d?\d?)?$/;
export const MILEAGE_LOG_ODOMETER_REGEX = /^(\d+)?$/;
export const MILEAGE_LOG_QUANTITY_REGEX = /^(\d+[.,]?\d?\d?\d?)?$/;

export const RULE_TYPE_CONTAINS = 1;
export const RULE_TYPE_EQUALS = 2;
export const RULE_TYPE_STARTS_WITH = 3;
export const RULE_TYPE_ENDS_WITH = 4;

export const PERIODICITY_DAILY = 1;
export const PERIODICITY_WEEKLY = 2;
export const PERIODICITY_MONTHLY = 3;
export const PERIODICITY_YEARLY = 4;
export const PERIODICITY_FIRST_MONDAY_MONTH = 5;
export const PERIODICITY_FIRST_WORKING_DAY_MONTH = 6;

export const LOCALES = [
  {value: "fr", label: "Français"},
  // {value: "en", label: "English"}
];
